import { useAppForm as useAppFormBase } from '@worldcoo/ui/components/form';
import { loadRecaptcha } from '@worldcoo/ui/lib/captcha';
import { useZodI18n } from './zod-i18n';
import { getRuntimeRecaptchaSiteKey } from './shared';
import { useEffect } from 'react';

function useRecaptcha() {
	useEffect(() => {
		// Warm api.js so a token is ready at submit; the load is one cached promise, so nothing double-injects.
		void loadRecaptcha(getRuntimeRecaptchaSiteKey());
	}, []);
}

export const useAppForm: typeof useAppFormBase = (...args) => {
	useZodI18n();
	useRecaptcha();
	return useAppFormBase(...args);
};
